import type { ReactElement, ReactNode, Ref } from 'react';
import { AnimatePresence } from 'framer-motion';
import { Cportal } from '../Cportal';
import type { DataElScope } from '@/utils/dataEl';
import type { CstretchmodalController } from './Cstretchmodal.types';
import { CstretchmodalOverlay } from './CstretchmodalOverlay';

interface CstretchmodalViewProps {
  bodyRef?: Ref<HTMLDivElement>;
  children?: ReactNode;
  className?: string;
  controller: CstretchmodalController;
  dataElScope: DataElScope;
  floatingFooter: boolean;
  footer?: ReactNode;
  header?: ReactNode;
  overlayPortalTargetId?: string;
  showBackButton: boolean;
  visible: boolean;
}

export function CstretchmodalView({
  bodyRef,
  children,
  className,
  controller,
  dataElScope,
  floatingFooter,
  footer,
  header,
  overlayPortalTargetId,
  showBackButton,
  visible,
}: CstretchmodalViewProps): ReactElement {
  return (
    <Cportal>
      <AnimatePresence onExitComplete={controller.completeExit}>
        {visible && (
          <>
            <CstretchmodalOverlay
              bodyRef={bodyRef}
              canClose={controller.canClose}
              className={className}
              dataElScope={dataElScope}
              floatingFooter={floatingFooter}
              footer={footer}
              handleClose={controller.handleClose}
              header={header}
              overlayPortalTargetId={overlayPortalTargetId}
              showBackButton={showBackButton}
              stopPropagation={controller.stopPropagation}
              styleModel={controller.styleModel}
              surfaceRef={controller.surfaceRef}
            >
              {children}
            </CstretchmodalOverlay>
          </>
        )}
      </AnimatePresence>
    </Cportal>
  );
}
